export enum OrderStatus {
  Pending = 'PEN',
  Proposal = 'PRO',
  Operation = 'OPE',
  Cancelled = 'CAN',
  Rejected = 'WTD',
  PartialRefund = 'PRF',
  TotalRefund = 'RFD',
  Expired = 'EXP',
}

export enum LoanStatus {
  Activated = 'ACT',
  closed = 'CLO',
  Contentious = 'CO',
}

export enum LoanSubStatus {
  Desist = 'DES',
  PepperCancelation = 'CEL',
  IntermediaryCancelation = 'INT',
  ClientCancelation = 'CLI',
  Refinancing = 'RFN',
  AutoClosure = 'AUT',
  PreContentious = 'PCO',
  ResidueClosure = 'RES',
  NonPaymentReopening = 'RPI',
  ContentiousReopening = 'RPC',
  ChargeCancelation = 'CCO',
  RefinancingCancelation = 'RFA',
  Rehabilitation = 'RHA',
  PaymentReopening = 'RPR',
  Transferred = 'TRF',
  LoanYield = 'CSP',
}

export enum RefundType {
  Total = 'TOTAL',
  Partial = 'PARTIAL',
}

export enum RefundTypeText {
  TFD = 'total',
  RFD = 'parcial',
}

export enum RefundStatus {
  PRO = 'En Proceso',
  RTR = 'Listo para devolver',
  RFD = 'Devuelto',
}
